import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getGallery } from '../Service/Api';
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';

const Gallery = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getGallery();
      setData(topperData);
    };
    fetchData();
  }, []);
 
  const emptyArray = [
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/gallery1.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/gallery2.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/gallery3.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/gallery3.png", description: "Stay tuned for latest updates" },
  ];

  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <div className="row">
        <Slider {...settings}>
            {data?.length > 0 ? data?.filter((div) => div.category === "PhotoGallery").map((item, index) => (
            <div className="item" key={index}>
              <div className="galleryimg">
                <div className="galleryimgbox">
                <LazyLoad>  <img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`} className="img-fluid" alt="St. Francis Xavier School" /></LazyLoad>
                  <div className="gallerydesc">
                    <Link to={`/SubGallery?id=${item._id}`} className="">View More</Link>
                    <h6>{item.title}</h6>
                  </div>
                </div>
              </div>
            </div>
          )) : (
            <div className="item">
              <div className="galleryimg">
                <div className="galleryimgbox">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/sld1.jpg" className="img-fluid" alt="St. Francis Xavier School" /></LazyLoad>
                  <div className="gallerydesc">
                    <Link to="#" className="">View More</Link>
                    <h6>Gallery Title</h6>
                  </div>
                </div>
              </div>
            </div>
          )}  
          
        </Slider>
      </div>
    </>
  )
}

export default Gallery